export class CommonConstant {
  static status_code = {
    success: '200',
    refresh: '401',
    refresh_msg: 'Expired',
    status_code_key: 'status_code'
  }
  static spinnerOn = 'on';
  static spinnerOff = 'off';
  static condition_key = {
    active_status: { key: 'activate', label: 'Activate', status: 'active' },
    deactive_status: { key: 'deactivate', label: 'Deactivate', status: 'inactive' }
  }
  static record_status = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
  ];

  static nameBgColors: string[] = ["bg-blue-dim", "bg-blue-dim", "bg-azure-dim", "bg-indigo-dim", "bg-info-dim", "bg-purple-dim", "bg-pink-dim", "bg-orange-dim", "bg-teal-dim", "bg-primary-dim", "bg-success-dim", "bg-warning-dim", "bg-danger-dim", "bg-secondary-dim", "bg-dark-dim", "bg-gray-dim", "bg-blue-dim", "bg-azure-dim", "bg-indigo-dim", "bg-info-dim", "bg-purple-dim", "bg-pink-dim", "bg-orange-dim", "bg-teal-dim", "bg-primary-dim", "bg-success-dim", "bg-warning-dim", "bg-danger-dim", "bg-secondary-dim", "bg-dark-dim", "bg-gray-dim"];
  static nameBorderColors: string[] = ["bg-outline-primary", "bg-outline-success", "bg-outline-info", "bg-outline-gray", "bg-outline-warning", "bg-outline-dark", "bg-outline-light", "bg-outline-secondary", "bg-outline-danger"];
  static imageBase64: string = 'data:image/png;base64,';
  static updateSuccessMsg: string = 'updated successfully...!';
  static success: string = 'Success';
  static error: string = 'Error';
  static createSuccessMsg: string = 'Created successfully...!';
 static responseKeys = {
  clients: 'clients',
  country: 'country',
  regions: 'regions',
  languages: 'languages',
  company_loans_type: 'company_loans_type',
  json_key: 'json_keys',
  json_value: 'json_values',
  key_dropdown: 'key_dropdown',
  language_dropdown: 'language_dropdown',
  menu_keys: 'menu_keys',
  mapped_keys: 'mapped_keys',
  total_records: 'total_records',
}
  static reportReferenceKeys = {
    loan: 'loan',
    time: 'Time',
    leave: 'Leave',
    exemption: 'Exemption',
  }
  static actionKeys = {
    approved: 'approved',
    rejected: 'rejected'
  }
static enable_key = [
  { enable_keys: 'Yes', value: 1 },
  { enable_keys: 'No', value: 0 }
];

static reference_type = {
    EMPLOYEE: 'employee',
    COMPANY: 'company',
    PAY_COMPONENTS: 'pay_components',
    COUNTRY: 'country',
    CLIENT: 'client',
    EMP_NEW_HIRE: 'emp_new_hire',
    EMP_REHIRE_HIRE: 'emp_rehire_hire',
    EMP_TERMINATION: 'emp_termination',
    EMP_CONTRACT_RENEWAL: 'emp_contract_renewal',
    EMP_DATA_IMPORT: 'emp_data_import',
    PAY_VARIABLES: 'pay_variables',
    COMPLIANCE_VARIABLES: 'compliance_variables'
  }

}


